import { getBrandedConfig, getBrandedEnvironmentConfig, getEnvironmentConfig, getImmutableConfig, } from '../configHelper.js';
import { VerticalsBrands } from '@framework/brands';
const definition = {
    _: {
        snowplow: {
            salesforcePartnerId: 'P0000',
            dataLayerVersion: '1.4.8',
            pageTemplate: 'article',
            salesforceDataproviderId: 'D0000',
            platform: 'web',
            pageDisplayFormat: 'responsive',
        },
    },
    focus: {
        isTextMilestoneTrackingEnabled: true,
    },
};
const channelDefinition = {
    _: {
        snowplow: {
            salesforcePartnerId: 'P0000',
            dataLayerVersion: '1.5.3',
            pageTemplate: 'homepage',
            salesforceDataproviderId: 'D0000',
            platform: 'web',
            pageDisplayFormat: 'responsive',
            snowplowConsent: 'n/a',
        },
    },
    bunte: {
        job: {
            pageJob: 'bunte-home',
            pageJobId: '0031',
        },
    },
    focus: {
        job: {
            pageJob: 'focus-online-home-app',
            pageJobId: '9998',
        },
    },
    fitforfun: {
        job: {
            pageJob: 'verticals',
            pageJobId: '0029',
        },
    },
    finanzen100: {
        job: {
            pageJob: 'f100-invest-comparers',
            pageJobId: '0002',
        },
    },
};
const galleryDefinition = {
    _: {
        snowplow: {
            salesforcePartnerId: 'P0000',
            dataLayerVersion: '1.7.0',
            pageTemplate: 'gallery',
            salesforceDataproviderId: 'D0000',
            platform: 'web',
            pageDisplayFormat: 'responsive',
        },
    },
};
const videoPageDefinition = {
    _: {
        snowplow: {
            salesforcePartnerId: 'P0000',
            dataLayerVersion: '1.7.0',
            pageTemplate: 'video-page',
            salesforceDataproviderId: 'D0000',
            platform: 'web',
            pageDisplayFormat: 'responsive',
        },
    },
};
const trackingByEnvironmentDefinition = {
    base: {
        _: {
            appId: '{brand}_web-dev',
            environment: 'dev',
        },
    },
    production: {
        _: {
            appId: '{brand}_web-prod',
            environment: 'prod',
        },
    },
};
export const trackingConfig = (brand) => getBrandedConfig(definition, brand);
export const channelTrackingConfig = (brand) => getBrandedConfig(channelDefinition, brand);
export const galleryTrackingConfig = (brand) => getBrandedConfig(galleryDefinition, brand);
export const videoPageTrackingConfig = (brand) => getBrandedConfig(videoPageDefinition, brand);
export const trackingConfigByEnvironment = (brand) => {
    const config = getBrandedEnvironmentConfig(trackingByEnvironmentDefinition, brand);
    return getImmutableConfig({
        ...config,
        appId: `${VerticalsBrands.includes(brand) ? 'bf.' : ''}${config.appId.replace('{brand}', brand)}`,
    });
};
export const trackingCpxDomains = [
    'x.burda-forward.com',
    'x.chip.de',
    'x.fitforfun.de',
    'x.efahrer.chip.de',
    'x.cinema.de',
    'x.tvspielfilm.de',
    'x.bunte.de',
    'x.finanzen100.de',
    'x.focus.de',
    'x.tvtoday.de',
    'x.netmoms.de',
    'x.streampicker.de',
    'x.cardscout.de',
    'x.shopredirect.de',
    'x.sparalarm.de',
];
const DEV_TRACKING_CPX_WILDCARD_DOMAIN = '.bf-cpx-development.aws.bfops.io';
const PRODUCTION_TRACKING_CPX_WILDCARD_DOMAIN = '.bf-cpx-production.aws.bfops.io';
export const trackingCpxWildcardDomainByEnvironmentDefinition = () => {
    const envDefinition = {
        base: {
            wildcardDomain: DEV_TRACKING_CPX_WILDCARD_DOMAIN,
        },
        production: {
            wildcardDomain: PRODUCTION_TRACKING_CPX_WILDCARD_DOMAIN,
        },
    };
    return getEnvironmentConfig(envDefinition);
};
export const persistentErrorPageIdsConfig = getImmutableConfig({
    bunte: '550e8400-e29b-41d4-a716-446655440001',
    chip: '550e8400-e29b-41d4-a716-446655440002',
    focus: '550e8400-e29b-41d4-a716-446655440003',
});
//# sourceMappingURL=tracking.config.js.map